import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { GenerateCoverLetterBody, GenerateCoverLetterResponse } from "@shared-kernel/application/ports/student/student-repository";

export const generateCoverLetter = createAsyncThunk<GenerateCoverLetterResponse, GenerateCoverLetterBody, { extra: Partial<Dependencies> }>(
  "coverLetter/generate",
  async (body: GenerateCoverLetterBody, { extra: { studentRepository } }) => {
    return studentRepository!.generateCoverLetter(body);
  },
);
